module.exports = __webpack_public_path__ + "img/example_identification_row.3ef5caa8.svg";